import { ConfigService } from './../config/config.service';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

export interface ResponseNniToken {
  nniToken: string;
}

@Injectable()
export class ConsumerCreditLauncherService {
  private SIMULATOR_TOKEN_API = `${this.configService.get('API_INTERNAL_URL')}${this.configService.get(
    'API_SIMULATOR_TOKEN_PATH',
  )}`;

  constructor(private httpClient: HttpClient, private configService: ConfigService) {}

  getSimulatorToken(processId: string): Observable<ResponseNniToken> {
    const simulatorUrl = `${this.SIMULATOR_TOKEN_API}${processId}`;
    return this.httpClient.get<ResponseNniToken>(simulatorUrl);
  }
}
